import { BaseModule } from '../../types';
import { useSiteData } from '../../providers/SiteDataProvider';
import React, { useMemo, useState } from 'react';
import { SiteContext } from '../../types/SiteContext';
import { TextAreaInput, TextInput, RadioButtons } from '../structure/FormItems';
import ReCAPTCHA from 'react-google-recaptcha';
import { DataBinder } from '../../data/DataBinder';

type FormItemType = {
    required: boolean;
    key: string;
    title?: string;
    itemType: string;
    values?: Array<{ title: string; value: string }>;
};

function validateEmail(email: string) {
    const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

const buildFormItems = (t: SiteContext['t']) => {
    const translation_firstname = t('firstname');
    const translation_lastname = t('lastname');
    const translation_company = t('company');
    const translation_mail = t('mail');
    const translation_message = t('message');

    const translation_m = t('male');
    const translation_w = t('female');

    let show_gender = true;
    if (
        !translation_m ||
        translation_m.length === 0 ||
        translation_m === 'n/a'
    ) {
        show_gender = false;
    }

    const formItems = new Array<FormItemType>();

    if (show_gender) {
        formItems.push({
            required: true,
            key: 'salutation',
            itemType: 'radio',
            values: [
                {
                    title: translation_w,
                    value: 'female',
                },
                {
                    title: translation_m,
                    value: 'male',
                },
            ],
        });
    }
    formItems.push(
        {
            required: true,
            key: 'firstname',
            title: translation_firstname,
            itemType: 'text',
        },
        {
            required: true,
            key: 'lastname',
            title: translation_lastname,
            itemType: 'text',
        },
        {
            required: true,
            key: 'mail',
            title: translation_mail,
            itemType: 'text',
        },
        {
            required: true,
            key: 'company',
            title: translation_company,
            itemType: 'text',
        },
        {
            required: true,
            key: 'message',
            title: translation_message,
            itemType: 'textarea',
        },
    );

    return formItems;
};
const Contact: BaseModule = ({ pageContent }) => {
    const { t, currentLanguage, apiUrl } = useSiteData();
    const [sent, setSent] = useState(false);
    const [shouldCheck, setShouldCheck] = useState(false);
    const [response, setResponse] = useState<undefined | string | null>(null);

    const { formItems, dataBinder } = useMemo(() => {
        const binder = new DataBinder();

        const items = buildFormItems(t).map((item) => {
            return {
                ...item,
                value: binder.bind(item!.key),
            };
        });

        return {
            formItems: items,
            dataBinder: binder,
        };
    }, [currentLanguage]);

    const translation_submit = t('Submit');
    const translation_error = t('Please fill out this field.');

    if (sent) {
        const translation_contactthank = t('contactthank');
        return (
            <div className="m-form-captcha abstractComponent">
                {translation_contactthank}
            </div>
        );
    }

    const validateFields = () => {
        let isInvalid = false;
        for (const item of formItems) {
            isInvalid =
                !item.value.getValue() || item.value.getValue().length === 0;

            if (
                !isInvalid &&
                item.key === 'mail' &&
                !validateEmail(item.value.getValue())
            ) {
                debugger;
                isInvalid = true;
            }

            if (isInvalid) break;
        }
        return !isInvalid;
    };
    const handleSubmit = () => {
        setShouldCheck(true);

        const validSuccess = validateFields();
        if (validSuccess) {
            const payload = dataBinder.changeSet;

            fetch(`/api/mail/send`, {
                method: 'post',
                body: JSON.stringify({
                    response,
                    payload,
                }),
                headers: { 'Content-Type': 'application/json' },
            })
                .then((res) => {
                    if (res.status === 200) {
                        setSent(true);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    return (
        <div>
            {formItems
                .filter((item) => item)
                .map((item, index) => {
                    if (!item) return null;

                    switch (item.itemType) {
                        case 'radio':
                            return (
                                <RadioButtons
                                    key={index}
                                    item={item}
                                    shouldCheck={shouldCheck}
                                    errorMessage={translation_error}
                                />
                            );
                        case 'text':
                            return (
                                <TextInput
                                    key={index}
                                    item={item}
                                    shouldCheck={shouldCheck}
                                    errorMessage={translation_error}
                                />
                            );
                        case 'textarea':
                            return (
                                <TextAreaInput
                                    key={index}
                                    item={item}
                                    shouldCheck={shouldCheck}
                                    errorMessage={translation_error}
                                />
                            );
                    }
                    return null;
                })}

            <div className="m-form-captcha abstractComponent">
                <ReCAPTCHA
                    key="recaptcha"
                    sitekey="6Le4uq0UAAAAAANOqmLY8dylFNgg_xs-0NyBs-Ss"
                    onChange={(r) => setResponse(r)}
                />
                {response || shouldCheck === false ? null : (
                    <div className="a-form-input--error">
                        {translation_error}
                    </div>
                )}
            </div>
            {
                <span onClick={handleSubmit} className="btn btn-default">
                    {translation_submit}
                </span>
            }
        </div>
    );
    //}
};

export default Contact;
